export default __webpack_public_path__ + "static/media/tennis.b1a1314a.jpg";